var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d;
import { inject } from "tsyringe";
import { GlobalConfig } from "../config";
import { perRestaurant } from "../di";
import { DefaultApartmentInfo, FulfillmentInstructions, FulfillmentInstructionsToken, Payment, PaymentAddress, PostCode, Restaurant, StreetAddress, } from "../ordering";
import { PurchaseOrderStorageManager } from "../storage";
let PaymentFactory = class PaymentFactory {
    constructor(globalConfig, purchaseOrderStorageManager, restaurant, fulfillmentInstructions) {
        this.purchaseOrderStorageManager = purchaseOrderStorageManager;
        this.restaurant = restaurant;
        this.fulfillmentInstructions = fulfillmentInstructions;
        this.country = globalConfig.country;
    }
    create() {
        const paymentAddress = new PaymentAddress({
            fulfillmentInstructions: this.fulfillmentInstructions,
            streetAddress: StreetAddress.empty(this.country),
            apartmentInfo: DefaultApartmentInfo.empty(),
            postCode: PostCode.empty(),
        });
        return Payment.fromStorageData({
            restaurant: this.restaurant,
            fulfillmentInstructions: this.fulfillmentInstructions,
            paymentAddress,
            storageData: this.purchaseOrderStorageManager.paymentStorageManager.restore(),
        });
    }
};
PaymentFactory = __decorate([
    perRestaurant(),
    __param(0, inject(GlobalConfig)),
    __param(3, inject(FulfillmentInstructionsToken)),
    __metadata("design:paramtypes", [typeof (_a = typeof GlobalConfig !== "undefined" && GlobalConfig) === "function" ? _a : Object, typeof (_b = typeof PurchaseOrderStorageManager !== "undefined" && PurchaseOrderStorageManager) === "function" ? _b : Object, typeof (_c = typeof Restaurant !== "undefined" && Restaurant) === "function" ? _c : Object, typeof (_d = typeof FulfillmentInstructions !== "undefined" && FulfillmentInstructions) === "function" ? _d : Object])
], PaymentFactory);
export { PaymentFactory };
